import axios from 'axios'

export default {
    state: {
        patients: JSON.parse(localStorage.getItem('patients')) || null,
    },
    getters: {
        selectedPatient(state) {
            return state.patients.patients.find(
                //  patient => patient.doctorID === this.$route.params.id
            );
        }
    },

    mutations: {
        getAllPatients(state, patients) {
            state.patients = patients
            localStorage.setItem('patients', JSON.stringify(patients))

        },
        selectPatient(state, patient) {
            state.selectedPatient = patient
        },
        blockPatient(state, userId) {
            state.patients[state.patients.findIndex(patient => patient.userProfile.userId === userId)].userProfile.isBlocked = true
        },
        unblockPatient(state, userId) {
            state.patients[state.patients.findIndex(patient => patient.userProfile.userId === userId)].userProfile.isBlocked = false
        },
    },

    actions: {
        getAllPatients({ commit }, credentials) {
            commit('setLoading', true)

            return new Promise((resolve, reject) => {
                axios.get(`${process.env.VUE_APP_BASE_URL}admin/travellers/list`,
                    {
                        params:
                        {
                            pageSize: credentials.pageSize,
                            pageNo: credentials.pageNo,
                            activeStatus: credentials.activeStatus,
                            sortBy: credentials.sortBy,
                            dir: credentials.dir,
                            country: credentials.country,
                            search: credentials.search
                        }
                    })
                    .then(res => {
                        const removeNull = res.data.results.filter(el => el)
                        console.log(removeNull)
                        commit('getAllPatients', removeNull)
                        commit('setLoading', false)
                        resolve(res)
                    })
                    .catch(err => {
                        commit('setLoading', false)
                        localStorage.removeItem('patients')
                        reject(err)
                        console.log(err.response)
                    })
            })

        },
        selectDoctor({ commit }, doctor) {
            commit('selectPatient', doctor)
        },


        blockPatient({ commit }, credentials) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.VUE_APP_BASE_URL}user/setBlock`, credentials)
                    .then(res => {
                        console.log(res)
                        commit('blockPatient', credentials.userId)
                        resolve(res)
                    })
                    .catch(err => {
                        console.log(err)
                        reject(err)
                    })
            })
        },
        unblockPatient({ commit }, credentials) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.VUE_APP_BASE_URL}user/setBlock`, credentials)
                    .then(res => {
                        console.log(res)
                        commit('unblockPatient', credentials.userId)
                        resolve(res)
                    })
                    .catch(err => {
                        console.log(err)
                        reject(err)
                    })
            })
        },
    }
}